import { Link, useLocation } from 'react-router';

import { Icon } from '@/ui';
import { permissionPhrase } from '@/ui/vocabulary';

interface DeniedState {
  readonly permission?: string;
}

/**
 * Shown when a signed-in user reaches a route their roles do not cover.
 *
 * Named rather than generic on purpose: "you do not have this capability" is
 * actionable, because the reader knows who to ask for it. A bare 403 page is
 * not.
 *
 * @returns the refusal page
 */
export function NotPermittedPage(): React.JSX.Element {
  const state = useLocation().state as DeniedState | null;

  return (
    <div className="fo-refusal">
      <Icon name="lock" size="2rem" />
      <h1>You do not have access to this page</h1>
      <p className="prose">
        {state?.permission === undefined
          ? 'Your roles do not include the capability it requires.'
          : `Your roles do not let you ${permissionPhrase(state.permission)}.`}{' '}
        Ask an owner or a manager in your workspace if you need it.
      </p>
      <Link to="/">Back to the workspace</Link>
    </div>
  );
}
